<template>
     <AccessControl :menuId="1" :menuSectionId="4" nameOfPage='User List' @accessGranted="handleAccess"></AccessControl>
    <MainLayout>
        <template v-slot:default>
            <!-- end: container -->
            <!-- begin: container -->
            <div class="container-fixed">

                <div class="flex flex-wrap items-center lg:items-end justify-between gap-5 pb-7.5">
                    <div class="flex flex-col justify-center gap-2">
                        <h1 class="text-xl font-semibold leading-none text-gray-900">
                            User List
                        </h1>
                    </div>
                    <div class="flex items-center gap-2.5">
                        <a  v-if="canWrite" class="btn btn-sm btn-success" @click="openModal">
                            Add User
                        </a>
                    </div>
                </div>
                <Notification ref="notificationRef" />
                <div class="card">
                    <div class="card-header card-header-bg flex-wrap gap-2">
                        <div class="flex flex-wrap gap-2 lg:gap-5">
                            <div class="flex"><label class="input input-sm"><i class="ki-filled ki-magnifier"></i><input
                                        value="" v-model="searchTerm" type="text" placeholder="Search table"
                                        @input="fetchData"></label>
                            </div>
                        </div>
                    </div>
                    <vue-good-table mode="remote" :server-side="true" :columns="columns" :rows="rows"
                        :total-rows="totalRows" :pagination-options="paginationOptions" :isLoading.sync="isLoading"
                        :search-options="{ enabled: false }" @page-change="onPageChange" @on-page-change="onPageChange"
                        @per-page-change="onPerPageChange" @sort-change="onSortChange">
                        <template #table-row="props">
                            <span v-if="props.column.field === 'actions'">
                                <a  v-if="canEdit" @click="handleEdit(props.row)" class="btn btn-sm btn-icon btn-clear btn-light"
                                    href="#">
                                    <i class="ki-filled ki-notepad-edit">
                                    </i>
                                </a>

                                <a v-if="canDelete" @click="handleDelete(props.row)" class="btn btn-sm btn-icon btn-clear btn-light"
                                    href="#">
                                    <i class="ki-filled ki-trash">
                                    </i>
                                </a>
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>

                    </vue-good-table>

                    <Modal :isVisible="showModal" @update:isVisible="showModal = $event">
                        <template v-slot:header>
                            <h2>Add User</h2>
                        </template>
                        <template v-slot:body>
                            <form @submit.prevent="submitForm">
                                <div class="flex flex-wrap -mx-3 mb-6">
                                    <div class="w-full px-3 mb-6 md:mb-1 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Deparment
                                        </label>
                                        <select required v-model="form.department_id"
                                            class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                            <option v-for="option in department_options" :key="option.option_id"
                                                :value="option.department_id">
                                                {{ option.department_name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="w-full px-3 mb-6 md:mb-1  text-left">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Position
                                        </label>
                                        <select id="position_id" required v-model="form.position_id"
                                            class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                            <option v-for="position in position_options" :key="position.position_id"
                                                :value="position.position_id">
                                                {{ position.position_name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-1  text-left">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            User Right
                                        </label>
                                        <select id="position_id" required v-model="form.user_right"
                                            class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                            <option v-for="user_right in user_right_options" :key="user_right.user_right_id"
                                                :value="user_right.user_right_id">
                                                {{ user_right.user_right_name }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            First Name
                                        </label>
                                        <input v-model="form.firstname"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="text" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Last Name
                                        </label>
                                        <input v-model="form.lastname"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="text" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Email
                                        </label>
                                        <input v-model="form.email"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="email" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Password
                                        </label>
                                        <input v-model="form.password"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="password" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Confirm Password
                                        </label>
                                        <input v-model="form.confirm_password"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="password" required>
                                    </div>
                                </div>
                                <div class="flex justify-end mt-4">
                                    <button type="button" @click="closeModal"
                                        class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-1">Close</button>
                                    <button type="submit"
                                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Save</button>
                                </div>
                            </form>
                        </template>
                    </Modal>


                    <Modal :isVisible="showModal2" @update:isVisible="showModal2 = $event" @click.stop>
                        <template v-slot:header>
                            <h2>Edit User</h2>
                        </template>
                        <template v-slot:body>
                            <form @submit.prevent="updateForm">
                                <div class="flex flex-wrap -mx-3 mb-6">

                                    <div class="w-full px-3 mb-6 md:mb-1 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Deparment
                                        </label>
                                        <select required v-model="currentItem.department_id"
                                            class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                            <option v-for="option in department_options" :key="option.option_id"
                                                :value="option.department_id">
                                                {{ option.department_name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="w-full px-3 mb-6 md:mb-1  text-left">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Position
                                        </label>
                                        <select id="position_id" required v-model="currentItem.position_id"
                                            class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                            <option v-for="position in position_options" :key="position.position_id"
                                                :value="position.position_id">
                                                {{ position.position_name }}
                                            </option>
                                        </select>                                      
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-1  text-left">
                                        <label
                                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            User Right
                                        </label>
                                        <select id="user_right_id" required v-model="currentItem.user_right_id"
                                            class="bg-gray-50 border border-gray-500 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                            <option v-for="user_right in user_right_options" :key="user_right.user_right_id"
                                                :value="user_right.user_right_id">
                                                {{ user_right.user_right_name }}
                                            </option>
                                        </select>                                     
                                    </div>


                                   


                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            First Name
                                        </label>
                                        <input v-model="currentItem.firstname"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="text" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Last Name
                                        </label>
                                        <input v-model="currentItem.lastname"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="text" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Email
                                        </label>
                                        <input v-model="currentItem.email"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="email" required>
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Password
                                        </label>
                                        <input v-model="currentItem.password"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="password">
                                    </div>

                                    <div class="w-full px-3 mb-6 md:mb-0 text-left">
                                        <label class="block uppercase text-gray-700 text-xs font-bold mb-2">
                                            Confirm Password
                                        </label>
                                        <input v-model="currentItem.confirm_password"
                                            class="appearance-none block w-full text-gray-700 border border-gray-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                            id="" type="password">
                                    </div>
                                </div>
                                <div class="flex justify-end mt-4">
                                    <button type="button" @click="closeModal2"
                                        class="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-1">Close</button>
                                    <button type="submit"
                                        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Update</button>
                                </div>
                            </form>
                        </template>
                    </Modal>



                </div>
            </div>
            <!-- end: container -->
        </template>
    </MainLayout>
</template>
<script>
import MainLayout from '@/components/MainLayout.vue'
import apiClient from '@/services/apigen'; // Import your configured Axios instance  
import { ref, watch, onMounted } from 'vue';
import { VueGoodTable } from 'vue-good-table-next';
import Modal from '@/components/utils/Modal.vue'
import 'vue-good-table-next/dist/vue-good-table-next.css';
import Loader from '@/components/utils/loader.vue';
import Swal from 'sweetalert2';
import Notification from '@/components/utils/Notification.vue';
import AccessControl from '@/components/utils/UserAccess.vue';

export default {
    name: 'DepartmentPage',
    components: {
        MainLayout,
        VueGoodTable,
        Modal,
        Notification,
        AccessControl
    },
    mounted() {
        this.DeparmentListOptions(); // Fetch options when the component is mounted
        this.PositionListOptions(); // Fetch options when the component is mounted
        this.RightListOptions(); // Fetch options when the component is mounted
    },

    setup() {
        const columns = ref([
            { label: '#', field: 'user_id', type: 'number', sortable: true },
            { label: 'Email', field: 'email', sortable: true },
            { label: 'First Name', field: 'firstname', sortable: true },
            { label: 'Last Name', field: 'lastname', sortable: true },
            { label: 'Department', field: 'department_name', sortable: true },
            { label: 'Position', field: 'position_name', sortable: true },
            { label: 'User Right', field: 'right_name', sortable: true },
            {
                sortable: false,
                label: 'Actions',
                field: 'actions',
                type: 'actions',
                actions: [
                    {
                        label: 'Edit',
                        icon: 'edit',
                        onClick: ""
                    },
                    {
                        label: 'Delete',
                        icon: 'delete',
                        onClick: ""
                    }
                ]
            }
        ]);

        const rows = ref([]);
        const totalRows = ref(0);
        const searchTerm = ref('');
        const currentPage = ref(1);
        const perPage = ref(20);
        const sortField = ref('firstname');
        const sortType = ref('asc');

        const paginationOptions = ref({
            enabled: true,
            mode: 'pages',
            perPageDropdown: [5, 10, 20],
            perPage: perPage.value,
            totalRecords: totalRows.value,
            currentPage: currentPage.value

        });

        const searchOptions = {
            enabled: true
        };

        // Function to fetch data from the server
        const fetchData = async (page) => {
            try {
                const params = {
                    page: page,
                    per_page: perPage.value,
                    sort_field: sortField.value,
                    sort_type: sortType.value,
                    search: searchTerm.value,
                };
                const { data } = await apiClient.get('/users', { params });
                rows.value = data.data || [];
                totalRows.value = data.total || 0;

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const onPageChange = ({ currentPage }) => {
            paginationOptions.currentPage = currentPage;
            fetchData(currentPage);
        };

        const onPerPageChange = ({ currentPerPage }) => {
            console.log('Per page changed to:', currentPerPage);
            perPage.value = currentPerPage;
            paginationOptions.value.perPage = currentPerPage;
            fetchData();
        };

        const onSortChange = ([sort]) => {
            console.log('Sort changed to:', sort);
            sortField.value = sort.field;
            sortType.value = sort.type;
            fetchData();
        };
        // Watch for changes to trigger fetchData
        watch([currentPage, perPage, sortField, sortType, searchTerm], fetchData, { immediate: true });
        return {
            columns,
            rows,
            totalRows,
            paginationOptions,
            searchTerm,
            onPageChange,
            onPerPageChange,
            onSortChange,
            isLoading: false
        };
    },
    methods: {
        handleEdit(data) {
            // this.DeparmentListOptions(); 
            // this.PositionListOptions(); 
            this.showInfo(data.user_id);
        },
        handleDelete(data) {

            let user_id = data.user_id;

            Swal.fire({
                title: 'Are you sure do you want to delete?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteData(user_id);
                }
            });

        },
        openModal() {
            this.showModal = true;
            //this.DeparmentListOptions(); 
            // this.PositionListOptions(); 
        },
        closeModal() {
            this.showModal = false;

        },
        closeModal2() {
            this.showModal2 = false;
        },
        async showInfo(dept_id) {

            let id = dept_id;
            const response = await apiClient.get(`/users/info/${id}`);
            console.log(response.data.data)
            this.currentItem = response.data.data; // Store the fetched data
            this.currentItem.position_id = response.data.data.position_id;
            this.currentItem.department_id = response.data.data.department_id;
            this.currentItem.user_right_id = response.data.data.user_right_id;
            this.showModal2 = true; // Show the modal

            // Optionally, you might want to update the state or show the result in the UI
        },
        async PositionListOptions() {


            try {
                const response = await apiClient.get('/position/get/all');
                if (response.data.status == true) { //

                    this.position_options = response.data.data;
                    console.log(this.position_options);
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);

            }
        },

        async RightListOptions() {
            try {
                const response = await apiClient.get('/user_right/get/all');
                if (response.data.status == true) { //
                    this.user_right_options = response.data.data;
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);

            }
        },

        

        async DeparmentListOptions() {


            try {
                const response = await apiClient.get('/department/get/all');
                if (response.data.status == true) {

                    this.department_options = response.data.data;

                }
            } catch (error) {
                console.error('Error submitting form:', error.response);

            }
        },
        async deleteData(id) {

            try {
                const response = await apiClient.delete('/users/delete', { data: { id: id } });
                if (response.data.status == true) { // or check for other success c
                    this.$refs.notificationRef.show('Successfully Deleted', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);

            }
        },
        async updateForm() {


            try {
                const response = await apiClient.put('/users/update', this.currentItem);

                if (response.data.status == true) { // or check for other success 
                    this.showModal2 = false;
                    this.$refs.notificationRef.show('Successfully Updated', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error updatting form:', error.response);

            }
        },
        async submitForm() {
            try {
                const response = await apiClient.post('/users/save', this.form);               
                if (response.data.status == true) {
                    this.showModal = false;
                    this.$refs.notificationRef.show('Successfully Saved', 'success', '1');
                } else {
                    this.$refs.notificationRef.show(response.data.message, 'error', '0');
                }
            } catch (error) {
                console.error('Error submitting form:', error.response);

            }
        },
        handleAccess({ canEdit, canDelete, canWrite }) {
            this.canEdit = canEdit;
            this.canDelete = canDelete;
            this.canWrite = canWrite;
        },

    },
    data() {
        return {
            showModal: false,
            form: {},
            showModal2: false,
            currentItem: '',
            department_options: [],
            position_options: [],
            user_right_options: [],
            canWrite: 0,
            canEdit: 0,
            canDelete: 0,
        };
    },


}
</script>


<style></style>